import { makeAutoObservable } from 'mobx';

import { basicRoundedRectangleConfig } from './shapeDefaults';

import type { ElementState } from '../../renderer/ElementState';
import type VideoCreatorStore from '../../stores/VideoCreatorStore';

export class ShapeProducer {
  private videoCreator: VideoCreatorStore;

  constructor(videoCreator: VideoCreatorStore) {
    this.videoCreator = videoCreator;
    makeAutoObservable(this);
  }
  config: ElementState['source'] = {};
  isPropsChanged = false;
  creatingNewShape = false;

  initializeConfig() {
    const defaultShapeSetting = basicRoundedRectangleConfig;
    return defaultShapeSetting;
  }

  getShapeConfig() {
    return this.config;
  }

  setDefaultShapeConfig(source: ElementState | null = null) {
    const config = this.initializeConfig();
    console.log('Setting default shape config', config);
    const defaultConfig = source || {
      ...config,
    };

    this.config = defaultConfig;
  }

  setShapeConfig(config: ElementState['source'] | undefined) {
    const configuration: ElementState['source'] = {
      ...(config || this.initializeConfig()),
    };
    this.config = configuration;
  }
}
